// es.js: PunchLog Spanish locale
// Natural, labor-law-aware Spanish.
// Key terms: "horas extras" (not "tiempo extra"), "período de pago" (not "período de salario"),
//   "registro de entrada/salida" for clock-in/out, "turno" for shift.
// Do NOT translate: PunchLog, version strings, HMAC, ECDSA, IndexedDB, format strings.
export default {
  shell_collapseSidebar: 'Contraer barra lateral',
  shell_expandSidebar: 'Expandir barra lateral',
  shell_navAriaLabel: 'Navegación principal',
  shell_offline: 'Sin conexión',
  shell_online: 'En línea',
  shell_sidebarAriaLabel: 'Navegación principal',
  shell_switchToDark: 'Cambiar a modo oscuro',
  shell_switchToLight: 'Cambiar a modo claro',
  shell_syncedAgo: 'Sincronizado {n}',
  shell_syncedHours: 'hace {n} h',
  shell_syncedJustNow: 'ahora mismo',
  shell_syncedMinutes: 'hace {n} min',
  shell_tabPlanner: 'Planificador',
  shell_tabReports: 'Informes',
  shell_tabScan: 'Escanear',
  shell_tabSettings: 'Ajustes',
  shell_tabTrack: 'Registrar',
  // ── AppShell ──────────────────────────────────────────────────────────────
  shell_tagline: 'Datos Laborales Verificados',

  shell_dunningAction: 'Actualizar Pago',
  shell_dunningDismiss: 'Descartar',
  shell_dunningMessage:
    'Su pago fallo. Actualice su metodo de pago para mantener su suscripcion activa.',

  entry_allWorkplaces: 'Todos los lugares de trabajo',
  entry_clearFilters: 'Limpiar',
  entry_colVariance: 'Variación',
  // ── EntryList ─────────────────────────────────────────────────────────────
  entry_filterAll: 'Todos',
  entry_filterJobSearch: 'Búsqueda de empleo',
  entry_filterOnCall: 'Guardia',
  entry_filterShift: 'Turno',
  entry_filterTravel: 'Viaje',
  entry_groupConcurrent: 'Agrupar simultáneos',
  entry_predictiveViolation: 'Violación de horario predictivo (<24h de aviso)',
  entry_recordMutation: 'Registrar cambio',
  entry_showVariance: 'Variación de horario',
  entry_varianceHint: '{n}h vs programado',

  dt_deleteRowConfirm:
    'Esto eliminará permanentemente esta fila. Esta acción no se puede deshacer.',
  dt_deleteRowTitle: 'Eliminar fila',
  dt_emptyTitle: 'Sin registros',
  entry_emptySub:
    'Haz un registro de entrada en la pestaña Registrar para comenzar a anotar tu tiempo.',
  entry_emptySubFiltered: 'Intenta limpiar los filtros anteriores.',
  entry_emptyTitle: 'Aún no hay registros',
  entry_emptyTitleFiltered: 'Sin registros coincidentes',

  entry_colDate: 'Fecha',
  entry_colHours: 'Horas',
  entry_colIn: 'Entrada',
  entry_colJob: 'Puesto',
  entry_colOut: 'Salida',
  entry_colStatus: 'Estado',
  entry_colType: 'Tipo',
  entry_colWorkplace: 'Lugar de trabajo',

  entry_concurrentBadge: '{n}× simultáneos',
  entry_typeJobSearch: 'búsqueda de empleo',
  entry_typeOnCall: 'guardia',
  entry_typeShift: 'turno',
  entry_typeTravel: 'viaje',

  entry_signedLock: 'Firmado: registro inmutable',
  entry_statusModified: 'Modificado',
  entry_statusOk: 'OK',
  entry_statusSealed: 'Sellado',
  entry_unseal: 'Desellar',
  entry_unsealConfirmBody:
    'Al desellar podras editar este registro. La version sellada original se conserva para recuperacion de auditoria, y la nueva copia editable nunca podra volver a sellarse.',
  entry_unsealTitle: 'Desellar registro',

  entry_concurrentHeading: '{n} actividades simultáneas, duración total {hours}h',
  entry_concurrentHint: 'Cambia a la vista dividida para editar o eliminar registros individuales.',
  entry_segColHours: 'Horas',
  entry_segColIn: 'Entrada',
  entry_segColJob: 'Puesto',
  entry_segColOut: 'Salida',
  entry_segColType: 'Tipo',

  entry_groupEntries: '{n} registro · {hours}h | {n} registros · {hours}h',

  entry_breakUnpaid: '{n} min no remunerados',
  entry_dlBreak: 'Descanso',
  entry_dlCreated: 'Creado',
  entry_dlJob: 'Puesto',
  entry_dlModified: 'Modificado',
  entry_dlNotes: 'Notas',

  entry_btnCancel: 'Cancelar',
  entry_btnDelete: 'Eliminar',
  entry_btnEdit: 'Editar',
  entry_btnSave: 'Guardar',
  entry_editBreak: 'Descanso (min)',
  entry_editClockIn: 'Registro de entrada',
  entry_editClockOut: 'Registro de salida',
  entry_editDate: 'Fecha',
  entry_editJobPlaceholder: 'p. ej. Cocinero de línea',
  entry_editJobTitle: 'Puesto de trabajo',
  entry_editNotes: 'Notas',
  entry_editType: 'Tipo',
  entry_editTypeJobSearch: 'Búsqueda de empleo',
  entry_editTypeOnCall: 'Guardia',
  entry_editTypeShift: 'Turno',
  entry_editTypeTravel: 'Viaje',

  entry_deleteBtnConfirm: 'Sí, eliminar',
  entry_deleteConfirm: '¿Eliminar este registro? Esta acción no se puede deshacer.',

  entry_bulkApply: 'Aplicar',
  entry_bulkClear: 'Limpiar selección',
  entry_bulkDelete: 'Eliminar seleccionados',
  entry_bulkSelected: '{n} seleccionados',
  entry_bulkToggle: 'Selección múltiple',
  entry_bulkType: 'Cambiar tipo…',
  entry_bulkTypeLabel: 'Tipo de entrada masivo',
  entry_bulkWp: 'Cambiar lugar de trabajo…',
  entry_bulkWpLabel: 'Lugar de trabajo masivo',
  entry_colCostCode: 'Código',
  entry_deselectAll: 'Desseleccionar todo',
  entry_selectAll: 'Seleccionar todo',
  entry_selectRow: 'Seleccionar fila',

  planner_chooseFile: 'Elegir archivo…',
  planner_importDesc:
    'Acepta JSON, CSV o Excel (.xls SpreadsheetML) exportados desde PunchLog. Cada fila se convierte en un registro de tiempo.',
  planner_importedSuccess: 'Se importó {n} registro. | Se importaron {n} registros.',
  // ── PlannerPanel ─────────────────────────────────────────────────────────
  planner_importTitle: 'Importar',
  planner_skippedBundles: 'Se omitió {n} paquete firmado. | Se omitieron {n} paquetes firmados.',
  planner_templateEntry: 'Descargar plantilla de entradas de tiempo',
  planner_templateSchedule: 'Descargar plantilla de horario',
  planner_xlsxError:
    '.xlsx no es compatible. Exporta como .xls o CSV desde PunchLog y vuelve a importar.',

  planner_exportCsvLabel: 'CSV',
  planner_exportCsvSub: 'Valores separados por comas, se abre en Excel y Numbers',
  planner_exportDolLabel: 'Informe de horas',
  planner_exportDolSub: 'PDF con todas tus horas y registros',
  planner_exportExcelLabel: 'Excel',
  planner_exportExcelSub: 'SpreadsheetML, formato .xls nativo',
  planner_exportInvoiceLabel: 'Factura PDF',
  planner_exportInvoiceSub: 'PDF de factura de horas facturables',
  planner_exportJsonLabel: 'JSON',
  planner_exportJsonSub: 'Historial de auditoría completo con todos los campos',
  planner_exportTitle: 'Exportar',
  planner_hostShareError: 'Error al alojar la factura. Inténtalo de nuevo.',
  planner_hostShareLabel: 'Alojar y compartir',
  planner_hostShareLinkCopied: 'Enlace copiado al portapapeles',
  planner_hostShareLinkFailed: 'No se pudo copiar el enlace',
  planner_hostShareSub: 'Enlace alojado que tu cliente puede abrir en un navegador',
  planner_invoiceUsageNudge: '{used} de {limit} enlaces alojados usados',

  planner_destDrive: 'Guardar en Drive',
  planner_destDriveHint: 'Conecta Google Drive en Ajustes para habilitar',
  planner_destLabel: 'Guardar en',
  planner_destLocal: 'Descargar',
  planner_destProviderAll: 'Ambas',
  planner_destProviderLabel: 'Guardar en qué unidad',
  planner_driveError: 'Error al subir. Revisa tu conexión e inténtalo de nuevo.',
  planner_driveSaved: 'Guardado en Google Drive',
  planner_driveUploading: 'Subiendo {name}…',
  planner_exportGroupSchedules: 'Horarios',
  planner_exportGroupTimeEntries: 'Registros de tiempo',
  planner_exportSchedCsvLabel: 'Horario (CSV)',
  planner_exportSchedCsvSub: 'fecha, empleado, lugar, horas de entrada/salida',
  planner_exportSchedExcelLabel: 'Horario (Excel)',
  planner_exportSchedExcelSub: 'SpreadsheetML, compatible con importación',
  planner_exportWorkplaceAll: 'Todos los lugares de trabajo',
  planner_exportWorkplaceLabel: 'Lugar de trabajo',
  planner_includeSeal: 'Incluir sello criptográfico',
  planner_includeSealHint: 'Agrega el token JWS o aviso de sin firma al PDF',
  planner_moreFormats: 'Más formatos',

  planner_btnExportData: 'Exportar',
  planner_cardCompliance: 'Informe de horas',
  planner_cardDataExport: 'Exportación de datos',
  planner_cardInvoice: 'Factura',
  planner_formatLabel: 'Formato',
  planner_invoiceHideOpts: 'Ocultar opciones',
  planner_invoiceShowOpts: 'Mostrar opciones',
  planner_noSchedules: 'No hay turnos programados para exportar',
  planner_scopeEntries: 'Registros de tiempo',
  planner_scopeLabel: 'Alcance',
  planner_scopeSchedules: 'Horarios',

  planner_btnExport: 'Exportar…',
  planner_btnImport: 'Importar…',
  planner_btnMySchedule: 'Mi horario',

  planner_auditAction: 'Acción',
  planner_auditActor: 'Autor',
  planner_auditEmpty: 'Aún no hay entradas de auditoría.',
  planner_auditLoading: 'Cargando registro de auditoría...',
  planner_auditTarget: 'Destino',
  planner_auditTime: 'Hora',
  planner_btnConfirm: 'Descargar',
  planner_dayAdd: 'Agregar a este dia',
  planner_dayAssignMember: 'Miembro del equipo',
  planner_dayAssignMemberPlaceholder: 'Elija un miembro del equipo',
  planner_dayAssignMemberRequired: 'Elija un miembro del equipo para asignar este turno.',
  planner_dayBreak: '{n} min de descanso',
  planner_dayBreakMins: 'Descanso (min)',
  planner_dayCopyShift: 'Copiar este turno a otro miembro',
  planner_dayCopyToPlaceholder: 'Copiar a...',
  planner_dayDeleteShift: 'Eliminar turno',
  planner_dayEnd: 'Fin',
  planner_dayErrorGeneric: 'Algo salio mal. Por favor intenta de nuevo.',
  planner_dayErrorTimes: 'La hora de inicio y fin son obligatorias.',
  planner_dayErrorWorkplace: 'Se requiere un lugar de trabajo.',
  planner_dayIn: 'Entrada',
  planner_dayLockedByManager:
    'Este turno está bloqueado por tu administrador y no se puede editar.',
  planner_dayLockShift: 'Bloquear este turno',
  planner_dayNoRecords: 'No hay registros para este dia.',
  planner_dayOut: 'Salida',
  planner_daySaveSchedule: 'Agregar turno',
  planner_daySaveTime: 'Registrar tiempo',
  planner_dayScheduledShifts: 'Turnos programados',
  planner_dayStart: 'Inicio',
  planner_dayTabAssign: 'Asignar',
  planner_dayTabSchedule: 'Horario',
  planner_dayTabTime: 'Tiempo registrado',
  planner_dayUnlockShift: 'Desbloquear este turno',
  planner_dayWorkplace: 'Lugar de trabajo',
  planner_dayWorkplacePlaceholder: 'Selecciona un lugar de trabajo',
  planner_dayYourShift: 'Tu turno',
  planner_manageAudit: 'Auditoría',
  planner_manageBtn: 'Administrar',
  planner_manageSchedules: 'Plantillas de horario',
  planner_manageTeam: 'Equipo',
  planner_manageTitle: 'Administrar',
  planner_manageWorkplaces: 'Lugares de trabajo',
  planner_mutationBtnCancel: 'Cancelar',
  planner_mutationBtnSave: 'Guardar',
  planner_mutationChangedBy: 'Cambiado por',
  planner_mutationChangedByPlaceholder: 'p. ej. Gerente Sarah',
  planner_mutationModalTitle: 'Registrar cambio de horario',
  planner_mutationMutated: 'Cambiado a',
  planner_mutationNotes: 'Notas',
  planner_mutationNotesPlaceholder: 'p. ej. Me enviaron un mensaje la noche anterior',
  planner_mutationNoticeHours: 'Aviso recibido (horas)',
  planner_mutationNoticeHoursPlaceholder: 'p. ej. 16',
  planner_mutationNoticeRequired: 'El campo de aviso es obligatorio.',
  planner_mutationOriginal: 'Turno original',
  planner_mutationShiftNotFound: 'Turno no encontrado.',
  planner_previewModalTitle: 'Vista previa del informe',
  planner_sectionSummary: 'Resumen',
  planner_statDays: 'Días',
  planner_statEstPay: 'Pago est.',
  planner_statModified: 'Modificados',
  planner_statOtDays: 'Días con HE',
  planner_statOtDaysTooltip:
    'Días donde el total de horas trabajadas superó {threshold}h. Se configura por centro de trabajo en Administrar > Centros de trabajo > Horas y HE > Umbral diario de HE (0 lo desactiva para ese centro de trabajo).',
  planner_statPeriod: 'Período',
  planner_statPredictive: 'Avisos insuficientes',
  planner_statTotalHours: 'Horas totales',
  planner_statUnsigned: 'Sin sellar',
  planner_statVarianceDays: 'Variación de horario',
  planner_statWorkplace: 'Lugar de trabajo',
  planner_viewManage: 'Administrar',
  planner_viewPlan: 'Plan',

  planner_mobileDays: '{n} días',
  planner_mobileOt: '{n} HE',
  planner_mobileTotalHours: '{n}h totales',
  planner_mobileUnsigned: '{n} sin sellar',

  planner_customFrom: 'Fecha inicio',
  planner_customTo: 'Fecha fin',
  planner_dateRangeSep: 'hasta',
  planner_filterAll: 'Todos',
  planner_filterCustom: 'Personalizado',
  planner_filterThisMonth: 'Este mes',
  planner_filterThisWeek: 'Esta semana',
  planner_sectionPeriod: 'Período',

  planner_groupDay: 'Día',
  planner_groupHint: 'Se aplica al cambiar a la vista de lista',
  planner_groupMonth: 'Mes',
  planner_groupNone: 'Ninguno',
  planner_groupShift: 'Turno',
  planner_groupWeek: 'Semana',
  planner_invoiceFrom: 'De (perfil de facturación)',
  planner_invoiceFromDefault: 'Perfil predeterminado',
  planner_invoiceGrouping: 'Ítems por',
  planner_invoiceLimitReached:
    'Límite de facturas del nivel gratuito alcanzado (5/mes). Mejora a Pro para facturas ilimitadas.',
  planner_invoiceNoProfile:
    'Agrega un perfil de facturación en Ajustes para mostrar tu nombre y dirección en las facturas.',
  planner_sectionGroupBy: 'Agrupar por',
  planner_sectionType: 'Tipo de entrada',
  planner_sectionWorkplace: 'Lugar de trabajo',

  planner_addLogEntry: 'Registrar entrada',
  planner_addSchedule: 'Horario',
  planner_sectionAdd: 'Agregar',

  planner_entryBtnSave: 'Guardar registro',
  planner_entryBtnSaved: '¡Guardado!',
  planner_entryBtnSaving: 'Guardando…',
  planner_entryFormBreak: 'Descanso',
  planner_entryFormDate: 'Fecha',
  planner_entryFormIn: 'Entrada',
  planner_entryFormOut: 'Salida',
  planner_entryFormPlace: 'Lugar',

  planner_rosterBizOnly: 'La importación de plantillas requiere el plan Business.',
  planner_schedBtnApply: 'Aplicar al rango',
  planner_schedBtnSave: 'Guardar horario',
  planner_schedBtnSaved: '¡Guardado!',
  planner_schedBtnSaving: 'Guardando…',
  planner_schedFormBreak: 'Descanso',
  planner_schedFormDays: 'Días',
  planner_schedFormEnd: 'Fin',
  planner_schedFormName: 'Nombre',
  planner_schedFormNamePlaceholder: 'p. ej. Lun–Vie 9–17',
  planner_schedFormStart: 'Inicio',

  planner_dowF: 'Vi',
  planner_dowM: 'Lu',
  planner_dowSa: 'Sa',
  planner_dowSu: 'Do',
  planner_dowTh: 'Ju',
  planner_dowTu: 'Ma',
  planner_dowW: 'Mi',

  planner_unsignedSeal: '{n} sin sellar',
  planner_viewCalendar: 'Calendario',
  planner_viewList: 'Lista',
  planner_viewTimesheet: 'Hoja de tiempo',
  planner_viewToggleLabel: 'Vista',

  planner_chartHoursByDay: 'Horas por día',
  planner_chartScheduleVariance: 'Variación de horario',
  planner_sectionCharts: 'Gráficas',

  planner_calMode3Day: '3 días',
  planner_calModeMonth: 'Mes',
  planner_calModeWeek: 'Semana',
  planner_calModeWorkWeek: 'Semana laboral',
  planner_calNavToday: 'Hoy',
  planner_teamViewerLabel: 'Ver horario de',
  planner_teamViewerMySchedule: 'Mi horario',
  planner_timesheetAutosave: 'Guardar automáticamente',
  planner_timesheetSaveAll: 'Guardar todo',
  planner_timesheetTotal: 'Total',
  planner_timesheetWeekTotal: 'Semana',
  // ── Timesheet grid ────────────────────────────────────────────────────────
  ts_addCode: 'Agregar código',
  ts_codePlaceholder: 'CÓDIGO',
  ts_labelPlaceholder: 'Etiqueta',
  ts_noCodesSub:
    'Agregue un código abajo o configure códigos en la configuración del lugar de trabajo.',
  ts_noCodesTitle: 'Sin códigos de costo configurados',
  ts_total: 'Total',
  ts_week: 'Semana',
  ts_wpGroup: '{name}',

  calendar_dowFri: 'Vie',
  calendar_dowMon: 'Lun',
  calendar_dowSat: 'Sáb',
  calendar_dowSun: 'Dom',
  calendar_dowThu: 'Jue',
  calendar_dowTue: 'Mar',
  calendar_dowWed: 'Mié',
  calendar_entryCount: '{n} registros',
  calendar_hoursLogged: '{n}h',
  calendar_hoursOf: 'de {n}h',
  calendar_hoursPlanned: '{n}h planificadas',
  calendar_legendIssue: 'Modificado/Sin firma',
  calendar_legendOt: 'HE >8h',
  calendar_legendScheduled: 'Programado',
  calendar_legendWorked: 'Trabajado',
  calendar_nextMonth: 'Mes siguiente',
  // ── CalendarGrid ─────────────────────────────────────────────────────────
  calendar_prevMonth: 'Mes anterior',

  config_btnAddWorkplace: 'Agregar lugar de trabajo',
  config_noWorkplaces: 'Aún no hay lugares de trabajo. Agrega uno abajo.',
  // ── WorkplaceConfig ───────────────────────────────────────────────────────
  config_sectionWorkplaces: 'Lugares de trabajo',
  config_unnamed: 'Sin nombre',

  config_btnAddTemplate: 'Agregar plantilla',
  config_noSchedules: 'Aún no hay plantillas',
  config_sectionSchedules: 'Plantillas de horario',

  config_bpAddressHeader: 'Dirección',
  config_bpCurrency: 'Moneda',
  config_bpCurrencyHint: 'Moneda usada para las facturas con este perfil',
  config_bpDefault: 'Perfil predeterminado',
  config_bpDefaultHint: 'Usar este perfil cuando no se seleccione ninguno',
  config_bpEmail: 'Correo electrónico',
  config_bpEmailPlaceholder: 'dirección de correo de facturación',
  config_bpIdentityHeader: 'Identidad',
  config_bpName: 'Nombre',
  config_bpNameHint: 'Aparece como el campo De en las facturas',
  config_bpNamePlaceholder: 'p. ej. Acme S.A. o Juan García',
  config_bpPreferencesHeader: 'Preferencias',
  config_btnAddBillingProfile: 'Agregar perfil',
  config_defaultWorkplaceName: 'Mi lugar de trabajo',
  config_deleteBpConfirm: '¿Eliminar este perfil de facturación?',
  config_editBillingProfile: 'Editar perfil de facturación',
  config_newBillingProfile: 'Nuevo perfil de facturación',
  config_noBillingProfiles: 'Aún no hay perfiles de facturación',
  config_sectionBillingProfiles: 'Perfiles de facturación',
  config_unitPerHour: '/h',

  config_dataPrivacy: 'Datos y privacidad',
  config_dataPrivacySub: 'Exportar, borrar registros, almacenamiento',
  config_dataSyncNav: 'Datos y sincronización',
  config_dataSyncNavSub: 'Almacenamiento, copia de seguridad y sincronización en la nube',
  config_integrations: 'Integraciones',
  config_integrationsSub: 'Webhooks, eventos salientes',
  config_planFeatures: 'Plan y funciones',
  config_sectionAppSettings: 'Ajustes de la aplicación',
  config_syncCloud: 'Sincronización y nube',
  config_syncCloudSub: 'Copia de seguridad y sincronización en la nube',
  config_teams: 'Equipos',
  config_teamsSub: 'Lugares de trabajo con varios miembros',
  sync_bpDefault: 'predeterminado',
  sync_btnDisconnect: 'Desconectar',
  sync_btnReconnect: 'Reconectar',
  sync_btnRetry: 'Reintentar',
  sync_btnSyncNow: 'Sincronizar ahora',
  sync_chooseHint: 'Elige un proveedor de nube para sincronizar tus datos entre dispositivos.',
  sync_connectAnother: 'Conecta otro proveedor de nube para sincronizar con ambos a la vez.',
  sync_connectError:
    'No se pudo conectar. Si no apareció una ventana de inicio de sesión, verifica que tu navegador no esté bloqueando ventanas emergentes para este sitio.',
  sync_googleDrive: 'Google Drive',
  sync_interactionInProgress:
    'Un intento de inicio de sesión anterior no terminó correctamente. Toca Reintentar para intentarlo de nuevo.',
  sync_lastSync: 'Última sincronización: {time}',
  sync_oneDrive: 'OneDrive',
  sync_statusConnected: 'Conectado',
  sync_statusConnecting: 'Conectando…',
  sync_statusError: 'Error',
  sync_statusExpired: 'Sesión expirada',
  sync_statusSyncing: 'Sincronizando…',

  config_editWorkplace: 'Editar lugar de trabajo',
  config_newWorkplace: 'Nuevo lugar de trabajo',

  config_address: 'Dirección',
  config_address1: 'Calle',
  config_address1Placeholder: 'Av. Principal 123',
  config_address2: 'Suite / Apto',
  config_address2Placeholder: 'Suite 100',
  config_addressHeader: 'Dirección',
  config_addressPlaceholder: 'Calle, ciudad, estado, código postal',
  config_city: 'Ciudad',
  config_defaultJobTitle: 'Puesto predeterminado',
  config_defaultJobTitleHint:
    'Se rellena automáticamente en nuevos registros de este lugar de trabajo',
  config_defaultJobTitlePlaceholder: 'p. ej. Cocinero, Ingeniero de Software',
  config_employerLegalName: 'Nombre de la entidad legal',
  config_employerLegalNameHint: 'Aparece en informes exportados y facturas',
  config_employerLegalNamePlaceholder: 'Para registros oficiales',
  config_identityHeader: 'Identificación',
  config_phone: 'Teléfono',
  config_phonePlaceholder: '+52 (55) 0000-0000',
  config_stateField: 'Estado',
  config_workplaceName: 'Nombre',
  config_workplaceNameHint: 'Use un nombre único por empleador o contrato',
  config_workplaceNamePlaceholder: 'p. ej. Bistró del Centro',
  config_workplaceNamePlaceholderContract: 'p. ej. Acme Corp – Fase 1',
  config_zip: 'Código postal',

  config_isContract: 'Este es un contrato / trabajo independiente',
  config_payCommission: 'Comisión',
  config_payHeader: 'Pago',
  config_payHourly: 'Por hora',
  config_paySalary: 'Salario fijo',
  config_payStructure: 'Estructura salarial',

  config_hourlyRate: 'Tarifa por hora',
  config_hourlyRateHint: 'Mínimo estatal: ${min}/h',

  config_payPeriod: 'Período de pago',
  config_payPeriodAnnual: 'Anual',
  config_payPeriodBiweekly: 'Quincenal',
  config_payPeriodMonthly: 'Mensual',
  config_payPeriodSemimonthly: 'Dos veces al mes (24×/año)',
  config_payPeriodWeekly: 'Semanal',
  config_salaryAmount: 'Monto del salario',
  config_salaryAmountContract: 'Tarifa fija',
  config_salaryAmountContractHint:
    'Tarifa fija periódica facturada independientemente de las horas registradas',

  config_baseRate: 'Tarifa horaria base (opcional)',
  config_baseRateContract: 'Tarifa horaria base (opcional)',
  config_baseRateHint: '0 = solo comisión',
  config_baseRateHintContract: 'Deje en blanco o ingrese 0 para comisión exclusiva',
  config_commissionPct: 'Comisión %',

  config_contractAmount: 'Monto',
  config_contractBilling: 'Tipo de facturación al cliente',
  config_contractBillingFixed: 'Precio fijo',
  config_contractBillingHourly: 'Por hora',
  config_contractBillingRetainer: 'Anticipo',
  config_contractDesc: 'Alcance / Entregable',
  config_contractDescPlaceholder: 'p. ej. Fase 1: integración de API',
  config_contractPeriod: 'Período de facturación',
  config_contractPeriodQuarterly: 'Trimestral',
  config_contractRetainerPlusHourlyHint: 'Base de anticipo + horas registradas facturadas encima',

  config_dailyOtHint: '0 = sin horas extras diarias',
  config_dailyOtThreshold: 'Umbral de horas extras diarias',
  config_defaultHoursDay: 'Horas predeterminadas por día',
  config_defaultUnpaidBreak: 'Descanso no remunerado predeterminado',
  config_defaultUnpaidBreakHint: 'Se pre-llena en nuevas entradas para este lugar de trabajo',
  config_hoursOtHeader: 'Horas y horas extras',
  config_weeklyOtThreshold: 'Umbral de horas extras semanales',

  config_complianceHeader: 'Cumplimiento normativo',
  config_flsaClass: 'Clasificación FLSA',
  config_flsaContractor: 'Contratista independiente (1099)',
  config_flsaExempt: 'Exento (salario fijo, sin horas extras)',
  config_flsaNonExempt: 'No exento (con derecho a horas extras)',
  config_flsaTrainee: 'Aprendiz / becario',

  config_roundDown15: 'Redondear hacia abajo 15 min',
  config_roundingHint: 'Se aplica a las horas de entrada y salida',
  config_roundNearest15: 'Al cuarto de hora más cercano',
  config_roundNone: 'Ninguno (exacto)',
  config_roundUp15: 'Redondear hacia arriba 15 min',
  config_stateOtRules: 'Estado (normas de horas extras)',
  config_timeRounding: 'Redondeo de tiempo',

  config_costCodesHeader: 'Códigos de costo',
  config_costCodesHint: 'Se muestran los predeterminados; editor por lugar de trabajo próximamente',
  config_costCodesLabel: 'Códigos activos para este lugar de trabajo',

  common_deleteRecord: 'Eliminar registro',
  common_deleteRecordConfirm: '¿Eliminar este registro? Esta acción no se puede deshacer.',
  common_deleteSelected: 'Eliminar seleccionados',
  common_deleteSelectedConfirm:
    '¿Eliminar {count} entrada seleccionada? Esta acción no se puede deshacer. | ¿Eliminar {count} entradas seleccionadas? Esta acción no se puede deshacer.',
  config_deleteBp: 'Eliminar perfil de facturación',
  config_deleteSchedule: 'Eliminar plantilla de horario',
  config_deleteWorkplace: 'Eliminar lugar de trabajo',
  config_mergeWorkplaceConfirm:
    '¿Fusionar {source} con {target}? Esta acción no se puede deshacer.',
  config_mergeWorkplaceCta: 'Fusionar con otro lugar de trabajo…',
  config_mergeWorkplaceHint:
    'Mueve cada entrada, plantilla de horario y turno programado de {name} al lugar de trabajo que elijas abajo, y luego elimina {name}. Esta acción no se puede deshacer.',
  config_mergeWorkplaceLabel: 'Fusionar con',
  config_mergeWorkplaceSelectPrompt: 'Elige un lugar de trabajo…',
  config_mergeWorkplaceTitle: 'Fusionar lugar de trabajo',

  config_btnCancel: 'Cancelar',
  config_btnDelete: 'Eliminar',
  config_btnSave: 'Guardar',
  config_btnSaveChanges: 'Guardar cambios',
  config_btnSaving: 'Guardando…',
  config_savedMsg: 'Guardado',

  config_btnSaveTemplate: 'Guardar plantilla',
  config_daysOfWeek: 'Días de la semana',
  config_editTemplate: 'Editar plantilla',
  config_endTime: 'Hora de fin',
  config_linkedWorkplace: 'Lugar de trabajo vinculado',
  config_linkedWorkplaceAny: 'Cualquiera',
  config_newScheduleTemplate: 'Nueva plantilla de horario',
  config_scheduleHeader: 'Horario',
  config_startTime: 'Hora de inicio',
  config_templateName: 'Nombre de la plantilla',
  config_templateNamePlaceholder: 'p. ej. Lun–Vie 9–17',
  config_unpaidBreak: 'Descanso no remunerado',

  config_dayFri: 'Vie',
  config_dayMon: 'Lun',
  config_daySat: 'Sáb',
  config_daySun: 'Dom',
  config_dayThu: 'Jue',
  config_dayTue: 'Mar',
  config_dayWed: 'Mié',
  config_noDaysScheduled: 'Sin días',

  config_btnClearRecords: 'Borrar registros de tiempo',
  config_btnExportAll: 'Exportar todos los datos (JSON)',
  config_clearDesc:
    'Elimina permanentemente todos los registros de tiempo locales. Los ajustes de lugares de trabajo y las plantillas de horario no se verán afectados. Esta acción no se puede deshacer.',
  config_dangerZone: 'Zona de peligro',
  config_dataHeader: 'Datos y privacidad',
  config_exportDesc:
    'Descarga una copia completa de todos los datos locales en JSON: lugares de trabajo, horarios y cada registro de tiempo, incluyendo el historial de auditoría completo.',
  config_exportSectionHeader: 'Exportar',

  config_clearTimeConfirm:
    'Todas las entradas de tiempo se eliminarán permanentemente. Los ajustes de trabajo y facturación no se ven afectados.',
  config_clearTimeDesc:
    'Elimina todas las entradas de turnos. Los lugares de trabajo, horarios y perfiles de facturación se conservan.',
  config_clearTimeLabel: 'Borrar registros de tiempo',

  config_btnClearWorkplaces: 'Eliminar lugares de trabajo',
  config_clearWorkplacesConfirm:
    'Todos los lugares de trabajo, plantillas de horario y turnos programados se eliminarán permanentemente. Los registros de tiempo no se ven afectados.',
  config_clearWorkplacesDesc:
    'Elimina todos los lugares de trabajo, plantillas de horario y turnos programados. Los registros de tiempo se conservan.',
  config_clearWorkplacesLabel: 'Eliminar lugares de trabajo y horarios',

  config_btnClearBilling: 'Eliminar perfiles de facturación',
  config_clearBillingConfirm: 'Todos los perfiles de facturación se eliminarán permanentemente.',
  config_clearBillingDesc:
    'Elimina todos los perfiles de facturación. Los registros de tiempo y lugares de trabajo se conservan.',
  config_clearBillingLabel: 'Eliminar perfiles de facturación',

  config_btnResetAll: 'Restablecer todos los datos locales',
  config_resetAllConfirm:
    'Todos los datos locales se borrarán permanentemente, incluidos los paquetes de auditoría firmados. Esta acción no se puede deshacer.',
  config_resetAllDesc:
    'Borra todos los datos locales: registros de tiempo, lugares de trabajo, horarios, perfiles de facturación y paquetes firmados. Empieza desde cero.',
  config_resetAllLabel: 'Restablecer todo',

  config_btnDeleteAccount: 'Eliminar Cuenta',
  config_deleteAccountConfirm:
    'Esto cancelará tu suscripción de Stripe (si la tienes), eliminará todos los datos del servidor (facturas, equipo, inquilino) y borrará todos los registros locales. Es permanente y no se puede deshacer.',
  config_deleteAccountDesc:
    'Cancelar suscripción activa, eliminar facturas y datos del equipo del servidor, y borrar todos los datos locales. Esta acción no se puede deshacer.',
  config_deleteAccountLabel: 'Eliminar Cuenta y Datos del Servidor',
  config_deleteAccountSuccess: 'Cuenta eliminada correctamente.',

  config_sheetBadUrl: 'No se encontró un ID de hoja en esa URL.',
  config_sheetBtnAdd: 'Agregar hoja',
  config_sheetBtnImport: 'Importar entradas',
  config_sheetBtnPull: 'Importar ahora',
  config_sheetBtnRemove: 'Eliminar',
  config_sheetConflict: 'Cuando una entrada importada se superpone con una existente',
  config_sheetConflictKeep: 'Conservar ambas',
  config_sheetConflictOver: 'Sobrescribir existente',
  config_sheetConflictSkip: 'Omitir (conservar existente)',
  config_sheetConnectHint: 'Conecta Google Drive en Ajustes para habilitar la importación.',
  config_sheetDefaultWp: 'Asignar a lugar de trabajo (opcional)',
  config_sheetDefaultWpNone: 'Sin lugar de trabajo',
  config_sheetDone: 'Listo: {imported} importadas, {skipped} omitidas.',
  config_sheetErrors: '{count} fila(s) con errores.',
  config_sheetImportDesc:
    'Pega un enlace a una hoja de cálculo de Google con datos de entradas de tiempo. La primera fila debe ser el encabezado.',
  config_sheetImportHeader: 'Importar desde Google Sheets',
  config_sheetImporting: 'Importando…',
  config_sheetLastPulled: 'Última importación {time}',
  config_sheetNeverPulled: 'Nunca importado',
  config_sheetsSectionHeader: 'Google Sheets',
  config_sheetSyncDesc:
    'Agrega hojas de Google para importarlas automáticamente en cada sincronización.',
  config_sheetSyncEmpty: 'No hay hojas añadidas aún.',
  config_sheetSyncHeader: 'Importación recurrente de hojas',
  config_sheetUrlLabel: 'URL de la hoja',
  config_sheetUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/…',

  config_aboutAuditTrail: 'Historial de auditoría',
  config_aboutAuditTrailValue: 'Inmutable, solo local',
  config_aboutHeader: 'Acerca de',
  config_aboutServerSync: 'Sincronización con servidor',
  config_aboutServerSyncValue: 'Ninguna (Plan gratuito)',
  config_aboutStorage: 'Almacenamiento',
  config_aboutStorageValue: 'En el dispositivo (IndexedDB)',
  config_aboutVersion: 'Versión',
  config_autoSignHint: 'Firma cada registro criptográficamente al registrar entrada/salida',
  config_autoSignLabel: 'Firmar entradas automáticamente',
  config_btnConfirmDelete: 'Eliminar',
  config_dangerExportHint:
    'Opcionalmente, exporta una copia de seguridad primero; puedes reimportarla más tarde.',

  config_planChangePlan: 'Cambiar Plan',
  config_planChecking: 'Buscando…',
  config_planCompare: 'Comparar todos los planes',
  config_planCurrentBadge: 'Actual',
  config_planFree: 'Gratis',
  config_planHeader: 'Plan y funciones',
  config_planHideComparison: 'Ocultar comparación',
  config_planLastChecked: 'Última comprobación {n}',
  config_planManage: 'Gestionar suscripción',
  config_planPerMonth: '/mes',
  config_planRefreshBtn: 'Buscar actualizaciones',
  config_planSeatsSuffix: ' puestos',
  config_planSoon: 'Próximamente',
  config_planStatus_active: 'Activo',
  config_planStatus_canceled: 'Cancelado',
  config_planStatus_free: 'Gratis',
  config_planStatus_past_due: 'Pago fallido',
  config_planStatusCancels: 'Se cancela',
  config_planStatusInvoiceLinks: 'enlaces alojados este mes',
  config_planStatusLabel: 'estado',
  config_planStatusSeats: 'puestos',
  config_planStatusTier: 'plan',
  config_planUpgrade: 'Actualizar',
  config_planUpgradeSuccess: 'Pago exitoso. Tu plan ha sido actualizado.',

  config_btnRemoveWebhook: 'Eliminar',
  config_btnSaveWebhook: 'Guardar',
  config_btnTestPayload: 'Probar payload',
  config_emittedEventsHeader: 'Eventos emitidos',
  config_integrationsHeader: 'Integraciones',
  config_webhookDesc:
    'PunchLog envía un POST firmado a tu URL en cada evento. Verifica las solicitudes con el encabezado X-PunchLog-Signature HMAC-SHA256.',
  config_webhookHeader: 'Endpoint del webhook',
  config_webhookSaved: 'Guardado.',
  config_webhookSecretHint: 'Se usa para calcular X-PunchLog-Signature. Mantenlo privado.',
  config_webhookSecretLabel: 'Secreto de firma',
  config_webhookSecretPlaceholder: 'Cadena aleatoria, ≥ 32 caracteres',
  config_webhookUrlHint: 'Debe ser HTTPS en producción',
  config_webhookUrlLabel: 'URL del endpoint',
  config_webhookUrlPlaceholder: 'https://ejemplo.com/webhook',
  config_webhookWarning:
    'Los webhooks requieren una suscripción Pro. Configúralos ahora: los eventos se encolan hasta que actualices.',

  config_evt_data_exported: 'Exportación completa de datos descargada',
  config_evt_invoice_created: 'Factura generada',
  config_evt_scan_created: 'Escaneo de documento OCR guardado',
  config_evt_schedule_created: 'Nueva plantilla de horario guardada',
  config_evt_schedule_deleted: 'Plantilla de horario eliminada',
  config_evt_schedule_updated: 'Plantilla de horario editada',
  // Descripciones de eventos individuales, clave config_evt_<nombre_con_punto_reemplazado>
  config_evt_shift_created: 'Nuevo registro de tiempo guardado',
  config_evt_shift_deleted: 'Registro de tiempo eliminado',
  config_evt_shift_signed: 'Lote sellado con firma criptográfica',
  config_evt_shift_updated: 'Registro de tiempo editado',
  config_evt_sync_flushed: 'Cola pendiente enviada tras reconectarse',
  config_evt_sync_queued: 'Registro almacenado localmente mientras estaba sin conexión',
  config_evt_workplace_created: 'Nueva configuración de lugar de trabajo agregada',
  config_evt_workplace_deleted: 'Lugar de trabajo eliminado',
  config_evt_workplace_updated: 'Ajustes del lugar de trabajo modificados',
  // Etiquetas de grupos de eventos, clave config_evtGroup_<grupo>
  config_evtGroup_entries: 'Registros de tiempo',
  config_evtGroup_invoices: 'Facturas y exportaciones',
  config_evtGroup_ocr: 'OCR',
  config_evtGroup_schedules: 'Horarios',
  config_evtGroup_sync: 'Sincronización',
  config_evtGroup_workplaces: 'Lugares de trabajo',

  config_teamsAddTeamModalTitle: 'Agregar un equipo',
  config_teamsBtnRemove: 'Eliminar',
  config_teamsCsvHint:
    'Una persona por línea: nombre, correo, rol (rol opcional, por defecto empleado).',
  config_teamsCsvImportBtn: 'Importar',
  config_teamsCsvLabel: 'Pega filas (nombre, correo, rol)',
  config_teamsCsvPlaceholder:
    "Jane Doe, jane{'@'}example.com, empleado\nJohn Smith, john{'@'}example.com, gerente",
  config_teamsCsvResult: '{invited} invitados, {skipped} omitidos',
  config_teamsCsvRowFailed: 'Fila {row}: no se pudo invitar a {email}',
  config_teamsCsvRowMissing: 'Fila {row}: falta nombre o correo',
  config_teamsDemote: 'Hacer empleado',
  config_teamsEmailPlaceholder: 'Correo electrónico',
  config_teamsEmployeeIdPlaceholder: 'ID de empleado (opcional)',
  config_teamsEmptyDesc: 'Invita a un miembro del equipo para comenzar.',
  config_teamsEmptyTitle: 'Aún no hay miembros del equipo',
  config_teamsHeader: 'Equipos',
  config_teamsInviteBtn: 'Invitar',
  config_teamsInviteCta: 'Invitar',
  config_teamsInviteModalTitle: 'Invitar miembros del equipo',
  config_teamsInviteModeCsv: 'Importar CSV',
  config_teamsInviteModeSingle: 'Invitación individual',
  config_teamsModalCancel: 'Cancelar',
  config_teamsNamePlaceholder: 'Nombre',
  config_teamsNewTeamBtn: 'Agregar equipo',
  config_teamsNewTeamPlaceholder: 'Nombre del nuevo equipo',
  config_teamsPromote: 'Hacer gerente',
  config_teamsRemoveConfirm:
    'Esto eliminará al miembro y liberará su lugar. Esta acción no se puede deshacer.',
  config_teamsRemoveTitle: 'Eliminar miembro del equipo',
  config_teamsRoleEmployee: 'Empleado',
  config_teamsRoleManager: 'Gerente',
  config_teamsSelectTeam: 'Seleccionar un equipo',
  config_teamsSelectTeamFirst: 'Selecciona un equipo para ver sus miembros.',
  config_teamsUpsellDesc: 'Invita miembros, asigna horarios y gestiona roles en tu equipo.',
  config_teamsUpsellTitle: 'La gestión de equipos requiere el plan Business',
  planner_auditUpsellDesc:
    'Ve quién hizo qué en tu equipo: invitaciones, cambios de rol y ediciones de horarios.',
  planner_auditUpsellTitle: 'El registro de auditoría del equipo requiere el plan Business',

  config_teamsAssignBreak: 'Descanso (min)',
  config_teamsAssignBtn: 'Asignar',
  config_teamsAssignDate: 'Fecha del turno',
  config_teamsAssignEmptyDesc: 'Elige a alguien de la lista para asignar un horario.',
  config_teamsAssignEmptyTitle: 'Selecciona un miembro del equipo',
  config_teamsAssignEnd: 'Hora de fin',
  config_teamsAssignHeader: 'Asignar horario para {name}',
  config_teamsAssignSaving: 'Firmando...',
  config_teamsAssignSelectWorkplace: 'Seleccionar lugar de trabajo',
  config_teamsAssignStart: 'Hora de inicio',
  config_teamsAssignWorkplace: 'Lugar de trabajo',

  config_teamsBatchAssignBtn: 'Asignar semana',
  config_teamsBatchAssignHeader: 'Asignar una plantilla para la semana',
  config_teamsBatchAssignNoneAssigned: 'No se asignó ningún turno.',
  config_teamsBatchAssignSelectTemplate: 'Selecciona una plantilla',
  config_teamsBatchAssignSummary: '{count} turno(s) asignado(s)',
  config_teamsBatchAssignTemplate: 'Plantilla de horario',
  config_teamsBatchAssignWeek: 'Semana de',

  config_clearRecordsConfirm:
    '¿Eliminar todos los registros de tiempo locales? Esta acción no se puede deshacer.',
  config_deleteScheduleConfirm: '¿Eliminar {name}?',
  config_deleteWorkplaceConfirm: '¿Eliminar {name}? Esta acción no se puede deshacer.',

  shift_addDefault: 'Agregar uno predeterminado',
  shift_advancedSetup: 'Configuración avanzada →',
  shift_createOne: 'Crear uno',
  shift_firstRunDesc:
    'Registra tu tiempo, protege tu salario y exporta hojas de horas a prueba de manipulaciones, todo en tu dispositivo.',
  shift_firstRunStep1: 'Agrega un lugar de trabajo (tu empleador o cliente)',
  shift_firstRunStep2: 'Registra entrada cuando comienza tu turno',
  shift_firstRunStep3: 'Exporta una hoja de horas cuando la necesites',
  // ── ShiftView ─────────────────────────────────────────────────────────────
  shift_firstRunTitle: 'Bienvenido a PunchLog',
  shift_noWorkplaceBanner: 'No hay lugar de trabajo configurado.',

  shift_btnCancelModal: 'Cancelar',
  shift_btnSaveModal: 'Guardar',
  shift_newWorkplaceTitle: 'Nuevo lugar de trabajo',
  shift_wpDefaultHours: 'Horas predeterminadas por día',
  shift_wpNameLabel: 'Nombre',
  shift_wpNamePlaceholder: 'p. ej. Diner Acme',
  shift_wpRateLabel: 'Tarifa por hora ($/h)',

  shift_exportDolSub: 'PDF firmado con tus horas y registros',
  shift_exportDolTitle: 'Informe de horas',
  shift_exportInvoiceSub: 'Factura al cliente con horas × tarifa',
  shift_exportInvoiceTitle: 'Factura PDF',
  shift_exportTitle: 'Exportar',

  shift_modeLive: 'Reloj en vivo',
  shift_modeManual: 'Entrada manual',

  shift_btnAddWorkplace: 'Agregar lugar de trabajo',
  shift_fieldEntryType: 'Tipo de registro',
  shift_fieldWorkplace: 'Lugar de trabajo',
  shift_selectWorkplace: 'Seleccionar lugar de trabajo',
  shift_typeJobSearch: 'Búsqueda de empleo',
  shift_typeOnCall: 'Guardia',
  shift_typeShift: 'Turno',
  shift_typeTravel: 'Viaje',
  shift_typeWork: 'Sesión de trabajo',

  shift_fieldJobTitle: 'Puesto de trabajo',
  shift_fieldRateOfPay: 'Tarifa salarial',
  shift_fieldSchedule: 'Plantilla de horario',
  shift_jobTitlePlaceholder: 'p. ej. Cocinero de línea',
  shift_scheduleNone: 'Ninguno',

  shift_clockInRounded: '→ redondeado a {time}',
  shift_fieldClockIn: 'Registro de entrada',
  shift_fieldClockOut: 'Registro de salida',
  shift_fieldDate: 'Fecha',

  shift_break15: '15 min',
  shift_break30: '30 min',
  shift_break45: '45 min',
  shift_break60: '1 h',
  shift_breakCustom: 'Personalizado',
  shift_breakHint: 'Se descuenta de las horas remuneradas',
  shift_breakNone: 'Ninguno',
  shift_breakPlaceholder: 'min',
  shift_fieldUnpaidBreak: 'Descanso no remunerado',

  shift_fieldNotes: 'Notas',
  shift_notesPlaceholder: 'Opcional…',

  shift_btnClockIn: 'Registrar entrada',
  shift_btnClockOut: 'Registrar salida',
  shift_idleHint:
    'Selecciona un lugar de trabajo y tipo en el formulario, luego registra la entrada.',

  shift_btnReset: 'Restablecer',
  shift_btnSaveEntry: 'Guardar registro',
  shift_btnSaving: 'Guardando…',
  shift_entrySaved: 'Registro guardado',
  shift_manualEnterTimes: 'Ingresa los horarios en el formulario',
  shift_manualEstPay: 'Est. {pay}',
  shift_manualPreviewTitle: 'Vista previa de entrada manual',
  shift_previewCompensable: 'Tiempo remunerado',
  shift_previewEstPay: 'Pago est.',
  shift_previewGross: 'Tiempo bruto',
  shift_previewOvertime: 'Horas extras',

  shift_sectionEntryDetails: 'Detalles del registro',

  shift_compensableToday: 'Horas remuneradas hoy',
  shift_sectionTodayActivity: 'Actividad de hoy',
  shift_spread: 'Jornada extendida',
  shift_travel: 'Viaje',

  shift_breakdown: 'Desglose de tiempo',
  shift_daysWorked: 'Días trabajados',
  shift_otHours: 'Horas extras',
  shift_sectionSignExport: 'Exportar',
  shift_sectionThisWeek: 'Esta semana',
  shift_totalHours: 'Horas totales',

  shift_ledgerTotal: 'Total: {hours}h remuneradas',
  shift_sectionTodayEntries: 'Registros de hoy',

  shift_btnExport: 'Exportar',
  shift_noManualEntries: 'Sin entradas manuales',
  shift_noTodayActivity: 'Sin actividad hoy',
  shift_sealAuditTrail: 'Historial de auditoría verificable',
  shift_sealNone: 'No hay registros para firmar',
  shift_sealPartial: 'Firmado parcialmente',
  shift_sealReady: '{n} registro sin firmar | {n} registros sin firmar',
  shift_sealSigned: 'Firmado',
  shift_sectionSealExport: 'Sellar y exportar',

  shift_otWarning: 'HE: {hours}h a 1,5× aplica',

  ocr_btnClear: 'Limpiar',
  ocr_btnImportToTrack: 'Importar a Registrar',
  ocr_btnScanDocument: 'Escanear documento',
  ocr_btnUploadDocument: 'Subir documento',
  // ── OcrView ───────────────────────────────────────────────────────────────
  ocr_parsedResult: 'Resultado analizado',
  ocr_scanning: 'Escaneando…',
  ocr_tapToScan: 'Toca para escanear',

  ocr_sectionDocType: 'Tipo de documento',
  ocr_typePayStub: 'Recibo de nómina',
  ocr_typePunchCard: 'Tarjeta de fichaje',
  ocr_typeSchedule: 'Horario',
  ocr_typeTimesheet: 'Parte de horas',

  ocr_extractDailyHours: 'Horas diarias',
  ocr_extractDate: 'Fecha',
  ocr_extractDateRange: 'Rango de fechas',
  ocr_extractDaysOfWeek: 'Días de la semana',
  ocr_extractEmployeeName: 'Nombre del empleado',
  ocr_extractEmpName: 'Nombre del empleador',
  ocr_extractGrossPay: 'Salario bruto',
  ocr_extractHourlyRate: 'Tarifa por hora',
  ocr_extractHoursWorked: 'Horas trabajadas',
  ocr_extractLocation: 'Ubicación',
  ocr_extractNetPay: 'Salario neto',
  ocr_extractOvertime: 'Horas extras',
  ocr_extractPayPeriod: 'Período de pago',
  ocr_extractPosition: 'Cargo / función',
  ocr_extractPunchIn: 'Horas de fichaje de entrada',
  ocr_extractPunchOut: 'Horas de fichaje de salida',
  ocr_extractShiftTimes: 'Horario del turno',
  ocr_extractTotalHours: 'Horas totales',
  ocr_sectionExtracts: 'Campos extraídos',

  ocr_privacyBanner:
    'El OCR se ejecuta en el dispositivo. Ningún dato del documento sale de tu teléfono.',

  ocr_noScansYet: 'Aún no hay escaneos',
  ocr_sectionRecentScans: 'Escaneos recientes',

  ocr_clockIn: 'Entrada',
  ocr_clockOut: 'Salida',
  ocr_comparisonCheckHint:
    'Este recibo muestra {gross} bruto / {net} neto. Compáralo con tus horas registradas en Informes.',
  ocr_comparisonTimesheetHint:
    'Este parte de horas muestra {hours} horas totales. Compáralo con tus horas registradas en Informes.',
  ocr_selectPair: 'Selecciona el par de entrada / salida',

  config_btnAddReportConfig: 'Nueva configuración',
  config_defaultBadge: 'Predeterminado',
  config_locationPlural: 'ubicaciones',
  config_locationSingular: 'ubicación',
  config_noReportConfigs:
    'Sin configuraciones de informes. Añade una para personalizar facturas y hojas de horas.',
  config_profilePlural: 'perfiles',
  config_profileSingular: 'perfil',
  config_reportConfigPlural: 'configuraciones',
  config_reportConfigSingular: 'configuración',
  config_sectionReportConfigs: 'Configuraciones de informes',
  config_templatePlural: 'plantillas',
  config_templateSingular: 'plantilla',
  ocr_btnCancelShifts: 'Descartar',
  ocr_btnConfirmShifts: 'Añadir al calendario',
  ocr_scheduleReviewHint:
    'Revisa los turnos encontrados en este horario antes de añadirlos a tu calendario.',
  ocr_scheduleReviewSkipped: 'No se pudo leer un día u horario para esta entrada. Se omitió.',
  ocr_scheduleReviewTitle: 'Confirmar turnos escaneados',
  rcs_hidePreview: 'Ocultar',
  rcs_previewHeader: 'Vista previa',
  rcs_showPreview: 'Mostrar vista previa',
  reports_clientsBadge: 'Pro',
  reports_clientsHeader: 'Clientes este mes',
  reports_clientsHours: 'Horas',
  reports_clientsInvoiceCount: '{n} factura(s) este mes',
  reports_clientsInvoiced: 'Facturado',
  reports_downloadTitle: 'Descargar',
  reports_emptySub:
    'Genera una factura o hoja de horas desde la pantalla de exportación para verla aquí.',
  reports_emptyTitle: 'Sin informes',
  reports_filterCreated: 'Fecha de creación',
  reports_filterIncluded: 'Fecha incluida',
  reports_filterType: 'Tipo de informe',
  reports_filterTypeAll: 'Todos',
  reports_filterTypeInvoice: 'Factura',
  reports_filterTypeTimesheet: 'Hoja de horas',
  reports_filterWorkplace: 'Lugar de trabajo',
  reports_filterWorkplaceAll: 'Todos los lugares de trabajo',
  reports_header: 'Informes y exportaciones',
  reports_invoicesEmpty: 'Sin facturas aún',
  reports_invoicesEmptySub: 'Envía una factura desde la pantalla de exportación para verla aquí.',
  reports_invoicesLoading: 'Cargando facturas…',
  reports_invoicesLocked: 'Las facturas de cliente son una función del nivel Basic',
  reports_invoicesLockedSub:
    'Actualiza a Freelancer Basic para ver el estado de tus facturas alojadas.',
  reports_invoicesStatus_sent: 'Enviada',
  reports_invoicesStatus_viewed: 'Vista',
  reports_navExportsSub: 'PDFs de hojas de horas y facturas',
  reports_navIntegrationsSub: 'Automatizacion de webhooks',
  reports_navInvoicesSub: 'Enlaces de factura alojados y estado',
  reports_scanComparisonDismiss: 'Descartar',
  reports_scanComparisonTitle: 'Comparacion de documento escaneado',
  reports_tabExports: 'Exportaciones PDF',
  reports_tabIntegrations: 'Integraciones',
  reports_tabInvoices: 'Facturas de cliente',
  rp_billTo: 'Facturar a',
  rp_colAmount: 'Importe',
  rp_colClockIn: 'Entrada',
  rp_colClockOut: 'Salida',
  rp_colDate: 'Fecha',
  rp_colDescription: 'Descripcion',
  rp_colHours: 'Horas',
  rp_colRate: 'Tarifa',
  rp_defaultLogoText: 'PunchLog',
  rp_employee: 'Empleado',
  rp_from: 'De',
  rp_labelInvoice: 'Factura',
  rp_labelTimesheet: 'Parte de horas',
  rp_page1: 'Pagina 1 de 1',
  rp_previewTitle: 'Vista previa del informe',
  rp_sampleClientAddress: 'Calle Mayor 1, Madrid 28001',
  rp_sampleClientName: 'Cliente de ejemplo S.L.',
  rp_sampleConsulting: 'Consultoria de software',
  rp_sampleDocs: 'Documentacion',
  rp_sampleFromEmail: "tu{'@'}email.com",
  rp_sampleFromName: 'Tu nombre / empresa',
  rp_sampleReview: 'Revision de codigo',
  rp_total: 'Total',

  rc_accentColor: 'Color de acento',
  rc_billingProfile: 'Perfil de facturacion',
  rc_billingProfileEmpty: 'Sin perfiles de facturacion. Crea uno en Ajustes.',
  rc_billingProfileNone: 'Ninguno (datos de muestra)',
  rc_headerEdit: 'Editar configuracion',
  rc_headerNew: 'Nueva configuracion',
  rc_logoText: 'Texto de logo',
  rc_logoTextHintFromBilling: 'Se usa el perfil de facturacion: {name}',
  rc_logoTextHintOverride: 'Reemplaza el nombre del perfil de facturacion.',
  rc_logoTextPlaceholder: 'Nombre de empresa como logo',
  rc_name: 'Nombre',
  rc_namePlaceholder: 'p. ej. Factura predeterminada',
  rc_orientation: 'Orientacion',
  rc_reportTitle: 'Titulo del informe',
  rc_reportTitlePlaceholder: 'Dejar en blanco para usar el titulo por defecto',
  rc_reportType: 'Tipo de informe',
  rc_sectionBranding: 'Marca',
  rc_sectionIdentity: 'Identidad',
  rc_sectionLayout: 'Diseno',
  rc_setDefault: 'Establecer como predeterminado',
  rc_showBillingName: 'Mostrar nombre del perfil de facturacion junto al logo',

  config_bpLogoAlt: 'Vista previa del logo',
  config_bpLogoChange: 'Cambiar logo',
  config_bpLogoHeader: 'Logo',
  config_bpLogoHint: 'PNG, JPG o SVG. Se muestra en facturas y exportaciones.',
  config_bpLogoLabel: 'Logo de empresa',
  config_bpLogoRemove: 'Eliminar',
  config_bpLogoUpload: 'Subir logo',
  ocr_tabRecent: 'Recientes',
  ocr_tabScan: 'Escanear',

  about_app_description:
    'Registro de horario y facturación sin conexión con un registro de auditoría criptográfico.',
  config_menuAbout: 'Acerca de',
  config_menuAboutSub: 'Versión e información de la aplicación',
  legal_footer_privacy: 'Politica de Privacidad',
  legal_footer_terms: 'Terminos de Servicio',
  legal_menuSub_privacy: 'Qué datos recopilamos y cómo se usan',
  legal_menuSub_terms: 'Términos de suscripción y uso aceptable',
  legal_privacy_changes_p1:
    'Podemos actualizar esta politica de vez en cuando. Los cambios importantes se anunciaran en la aplicacion. La fecha de "Ultima actualizacion" en la parte superior de esta pagina refleja la revision mas reciente.',
  legal_privacy_changes_title: 'Cambios a Esta Politica',
  legal_privacy_cloudSync_p1:
    'Si conecta Google Drive o OneDrive, PunchLog crea una copia de respaldo de sus datos locales en su propia cuenta de almacenamiento en la nube. Los datos se cifran en transito (HTTPS) y se almacenan en su unidad personal. PunchLog nunca tiene acceso para leer sus datos sincronizados. Puede desconectar la sincronizacion en la nube en cualquier momento.',
  legal_privacy_cloudSync_title: 'Sincronizacion en la Nube (Opcional)',
  legal_privacy_contact_title: 'Contacto',
  legal_privacy_dataCollected_intro:
    'PunchLog recopila las siguientes categorias de datos. Todos los datos se almacenan localmente en su dispositivo:',
  legal_privacy_dataCollected_invoices:
    'Los datos de facturas se generan localmente en su dispositivo. En niveles de pago, las URLs de facturas alojadas se almacenan en Cloudflare R2 para admitir el uso de enlaces.',
  legal_privacy_dataCollected_invoices_label: 'Facturas',
  legal_privacy_dataCollected_location:
    'Capturada cuando ficha entrada y salida, si otorga permiso de ubicacion. Almacenada solo localmente en su dispositivo y nunca subida a nuestros servidores.',
  legal_privacy_dataCollected_location_label: 'Ubicacion GPS',
  legal_privacy_dataCollected_scan:
    'El procesamiento OCR se ejecuta completamente en su dispositivo. Las imagenes de documentos nunca se suben a ningun servidor.',
  legal_privacy_dataCollected_scan_label: 'Documentos Escaneados',
  legal_privacy_dataCollected_schedule:
    'Nombres de lugares de trabajo, direcciones, plantillas de horarios y registros de turnos. Todos los datos permanecen en su dispositivo.',
  legal_privacy_dataCollected_schedule_label: 'Datos de Horarios',
  legal_privacy_dataCollected_title: 'Datos Recopilados',
  legal_privacy_dataCollected_wages:
    'Tarifas por hora, montos salariales, duracion de descansos y horas calculadas. Almacenados en la base de datos local de su dispositivo. Sincronizados solo con su propio Google Drive o OneDrive si habilita la sincronizacion en la nube.',
  legal_privacy_dataCollected_wages_label: 'Salarios y Horas',
  legal_privacy_localStorage_p1:
    'Todos los datos principales se almacenan localmente en su dispositivo en una base de datos integrada. Estos datos no son accesibles para otros sitios web o aplicaciones. Si borra los datos de su navegador o aplicacion, los datos de PunchLog se eliminan de forma permanente e irreversible. Recomendamos exportar sus datos regularmente desde Ajustes > Datos y Privacidad.',
  legal_privacy_localStorage_title: 'Almacenamiento Local',
  legal_privacy_noTracking_p1:
    'PunchLog no contiene SDKs de anuncios, rastreadores de analitica ni telemetria de terceros. No vendemos sus datos. No usamos cookies para rastreo.',
  legal_privacy_noTracking_title: 'Sin Rastreo, Sin Anuncios',
  legal_privacy_overview_p1:
    'PunchLog esta disenado para minimizar los datos que recopilamos. Sus registros de tiempo, salarios, ubicaciones GPS y notas personales nunca salen de su dispositivo a menos que habilite explicitamente la sincronizacion en la nube. Esta politica describe que datos recopilamos y como los usamos.',
  legal_privacy_overview_title: 'Resumen',
  legal_privacy_servers_p1:
    'Para suscriptores de pago, Cloudflare D1 almacena estado de suscripcion, nivel, cantidad de asientos y registros de facturas alojadas. Cloudflare R2 almacena PDFs de facturas alojadas. Estos datos se limitan a lo necesario para proporcionar las funciones de su suscripcion. No almacenamos sus registros de tiempo, salarios o notas personales en ningun servidor.',
  legal_privacy_servers_title: 'Datos en el Servidor (Solo Niveles de Pago)',
  legal_privacy_signing_p1:
    'La pista de auditoria de PunchLog usa hash SHA-256. Cuando sella sus registros de tiempo, solo un hash hexadecimal de 64 caracteres de sus datos sale de su dispositivo. No se envian nunca al servidor de firma salarios, ubicaciones, nombres de empleadores o notas de turnos. El servidor de firma no puede revertir el hash para recuperar sus datos.',
  legal_privacy_signing_title: 'Firma Critografica de Conocimiento Cero',
  legal_privacy_stripe_p1:
    'Las suscripciones de pago son procesadas por Stripe. PunchLog no almacena su numero de tarjeta de credito. La politica de privacidad de Stripe rige los datos de pago: https://stripe.com/privacy.',
  legal_privacy_stripe_title: 'Procesamiento de Pagos',
  legal_privacy_thirdParty_cloudflare:
    'Cloudflare: backend sin servidor y almacenamiento (cloudflare.com/privacypolicy)',
  legal_privacy_thirdParty_gdrive:
    'Google Drive: sincronizacion opcional en la nube del usuario (policies.google.com/privacy)',
  legal_privacy_thirdParty_onedrive:
    'OneDrive: sincronizacion opcional en la nube del usuario (microsoft.com/privacy)',
  legal_privacy_thirdParty_p1:
    'PunchLog se integra con los siguientes servicios de terceros, cada uno sujeto a sus propias politicas de privacidad:',
  legal_privacy_thirdParty_stripe: 'Stripe: procesamiento de pagos (stripe.com/privacy)',
  legal_privacy_thirdParty_title: 'Servicios de Terceros',
  legal_privacy_title: 'Politica de Privacidad',
  legal_tos_acceptableUse_b1: 'Usar PunchLog para propositos ilegales.',
  legal_tos_acceptableUse_b2:
    'Intentar hacer ingenieria inversa, descompilar o extraer algoritmos propietarios de la aplicacion.',
  legal_tos_acceptableUse_b3:
    'Usar herramientas automatizadas para interactuar con la aplicacion de manera que eluda los limites de velocidad o la facturacion.',
  legal_tos_acceptableUse_p1: 'Usted acepta no:',
  legal_tos_acceptableUse_title: 'Uso Aceptable',
  legal_tos_changes_p1:
    'Podemos actualizar estos terminos de vez en cuando. Los cambios importantes se anunciaran en la aplicacion. La fecha de "Ultima actualizacion" en la parte superior de esta pagina refleja la revision mas reciente. El uso continuado de PunchLog despues de que los cambios entren en vigor constituye la aceptacion de los terminos revisados.',
  legal_tos_changes_title: 'Cambios a Estos Terminos',
  legal_tos_contact_title: 'Contacto',
  legal_tos_data_p1:
    'Usted es dueño de sus datos de registro de tiempo. PunchLog almacena datos localmente en su dispositivo. Los metadatos de niveles de pago (estado de suscripcion, cantidad de asientos, facturas alojadas) se almacenan en Cloudflare D1 para proporcionar las funciones de su suscripcion. Puede exportar todos sus datos en cualquier momento desde Ajustes > Datos y Privacidad.',
  legal_tos_data_title: 'Sus Datos',
  legal_tos_freeTier_p1:
    'El nivel gratuito proporciona seguimiento de tiempo local sin necesidad de crear cuenta. Sus datos permanecen en su dispositivo y no se respaldan en ningun servidor. Los usuarios del nivel gratuito pueden crear hasta 5 enlaces de factura alojados por mes.',
  legal_tos_freeTier_title: 'Nivel Gratuito',
  legal_tos_liability_p1:
    'PunchLog se proporciona "tal cual" sin garantias de ningun tipo. No somos responsables de ningun dano que surja del uso de la aplicacion, incluyendo pero no limitado a perdida de datos, calculos de horas inexactos o plazos legales perdidos.',
  legal_tos_liability_title: 'Limitacion de Responsabilidad',
  legal_tos_notLegalAdvice_p1:
    'PunchLog es una herramienta de seguimiento de tiempo y facturacion. Nada en esta aplicacion, incluyendo informes exportados, hojas de tiempo, paquetes de auditoria o cualquier otro contenido generado, constituye asesoramiento legal. PunchLog no mantiene ninguna relacion abogado-cliente con ningun usuario.',
  legal_tos_notLegalAdvice_p2:
    'Debe consultar a un abogado calificado para orientacion legal sobre disputas salariales, cumplimiento laboral, quejas salariales o cualquier otro asunto legal. Los documentos exportados son registros de sus propios datos, no presentaciones legales.',
  legal_tos_notLegalAdvice_title: 'No es Asesoramiento Legal',
  legal_tos_subscription_b1:
    'Las suscripciones se renuevan mensualmente a menos que cancele antes de su proxima fecha de facturacion.',
  legal_tos_subscription_b2:
    'Puede cancelar en cualquier momento a traves del Portal de Clientes de Stripe, accesible desde la pantalla de Plan y Caracteristicas. No se le cobrara nuevamente despues de la cancelacion.',
  legal_tos_subscription_b3:
    'Tras la cancelacion, su suscripcion permanece activa hasta el final del periodo de facturacion actual.',
  legal_tos_subscription_b4:
    "Las solicitudes de reembolso se manejan caso por caso. Contacte support{'@'}ddproxy.com.",
  legal_tos_subscription_p1:
    'Las suscripciones de pago se procesan a traves de Stripe. Al suscribirse, acepta los siguientes terminos:',
  legal_tos_subscription_title: 'Suscripcion y Facturacion',
  legal_tos_title: 'Terminos de Servicio',
  // ── Paginas legales ─────────────────────────────────────────────────────
  legal_updated: 'Ultima actualizacion',

  // ── Facturacion / Historial de facturas ──────────────────────────────────
  billing_historyHeader: 'Pagos Recientes',
  billing_loading: 'Cargando historial de pagos…',
  billing_noInvoices: 'Sin historial de pagos aun.',
  billing_status_draft: 'Borrador',
  billing_status_open: 'Abierto',
  billing_status_paid: 'Pagado',
  billing_status_past_due: 'Vencido',
  billing_status_uncollectible: 'Incobrable',
  billing_status_unknown: 'Desconocido',
  billing_status_void: 'Anulado',
  billing_viewReceipt: 'Recibo',

  help_contactBody:
    'Tienes una pregunta o necesitas ayuda? Envianos un correo y te responderemos lo antes posible.',
  help_contactHeader: 'Contactanos',
  help_faq_auditTrailBody:
    'Cuando sellas tus registros de tiempo, PunchLog genera un hash SHA-256 de tus datos. Solo el hash sale de tu dispositivo. Nunca se envian salarios, ubicaciones ni notas al servidor. El sello demuestra que tus registros no han sido alterados desde el sellado.',
  help_faq_auditTrailTitle: 'Como funciona el rastro de auditoria criptografico?',
  help_faq_cancelBody:
    'Ve a Ajustes, luego a Plan y Funciones. Toca Gestionar Suscripcion para abrir el portal de clientes de Stripe donde puedes cancelar o cambiar tu plan. Tu suscripcion permanece activa hasta el final del periodo de facturacion actual. Tus datos de tiempo permanecen en tu dispositivo despues de la cancelacion.',
  help_faq_cancelTitle: 'Como cancelo mi suscripcion?',
  help_faq_cloudSyncBody:
    'Ve a Ajustes, luego a Sincronizacion y Nube. Toca Conectar para vincular tu cuenta de Google Drive o Microsoft OneDrive. Una vez conectada, PunchLog respalda tus datos en tu almacenamiento en la nube. Tambien puedes guardar exportaciones directamente en tu unidad conectada.',
  help_faq_cloudSyncTitle: 'Como conecto Google Drive u OneDrive?',
  help_faq_exportBody:
    'Abre la pestana Planificador, selecciona tu rango de fechas y toca Exportar. Elige "Informe de horas" para generar un PDF con todas tus horas, registros y un sello criptografico opcional para evidencia de manipulacion.',
  help_faq_exportTitle: 'Como exporto un paquete de auditoria de registros salariales?',
  help_faq_invoiceLimitBody:
    'Cada plan incluye un limite mensual de enlaces de factura alojados. El plan gratuito incluye 5 al mes. Consulta tu uso actual en Ajustes bajo Plan y Funciones, o actualiza para obtener un limite mayor.',
  help_faq_invoiceLimitTitle: 'Por que no puedo crear un enlace de factura alojado?',
  help_faqHeader: 'Preguntas Frecuentes',
  // ── Ayuda y Soporte ─────────────────────────────────────────────────────
  help_title: 'Ayuda y Soporte',

  notif_bellAria: 'Notificaciones',
  notif_dismiss: 'Descartar',
  notif_empty: 'Sin notificaciones',
  notif_invoiceLimitBody:
    'Alcanzaste el limite mensual de enlaces de factura alojados. Actualiza tu plan para un limite mayor, o a Business para enlaces ilimitados.',
  notif_invoiceLimitTitle: 'Limite de facturas alcanzado',
  notif_markAllRead: 'Marcar todo como leido',
  notif_pastDueBody:
    'No se pudo procesar el pago de tu suscripcion. Actualiza tu metodo de pago para mantener tu plan activo.',
  notif_pastDueTitle: 'Pago fallido',
  // ── Notificaciones ───────────────────────────────────────────────────────
  notif_title: 'Notificaciones',

  account_codeLabel: 'Codigo de verificacion',
  account_codePlaceholder: 'Codigo de 6 digitos',
  account_codeSent: 'Codigo enviado. Revisa tu bandeja de entrada.',
  account_digestLabel: 'Resumen mensual por correo',
  account_digestOff: 'Desactivado',
  account_digestOn: 'Activado',
  account_emailLabel: 'Direccion de correo electronico',
  account_emailPlaceholder: "tu{'@'}ejemplo.com",
  account_errorSending: 'No se pudo enviar el codigo.',
  account_errorVerifying: 'No se pudo verificar el codigo.',
  account_sendCode: 'Enviar codigo',
  account_sending: 'Enviando...',
  account_signedIn: 'Sesion iniciada correctamente.',
  account_signedInAs: 'Sesion iniciada como',
  account_signedOut: 'Sesion cerrada.',
  account_signOut: 'Cerrar sesion',
  account_signOutConfirmBody:
    'Deberas ingresar tu correo y un nuevo codigo para iniciar sesion de nuevo.',
  account_signOutConfirmTitle: 'Cerrar sesion?',
  // ── Cuenta ──────────────────────────────────────────────────────────────
  account_title: 'Cuenta',
  account_unauthHint:
    'Inicie sesion para sincronizar sus datos entre dispositivos, obtener facturas alojadas y gestionar su suscripcion.',
  account_verify: 'Verificar',
  account_verifying: 'Verificando...',

  // ── Tier badge ─────────────────────────────────────────────────────────
  tierBadge_requires: 'Requiere {tier}',

  invoice_amountDue: 'Monto adeudado',
  invoice_billTo: 'Facturar a',
  invoice_colAmount: 'Monto',
  invoice_colDescription: 'Descripcion',
  invoice_colHours: 'Horas',
  invoice_colRate: 'Tarifa',
  invoice_from: 'De',
  invoice_issued: 'Emitida',
  // ── Public invoice view ──────────────────────────────────────────────────
  invoice_loading: 'Cargando factura…',
  invoice_notFound:
    'No se pudo encontrar esta factura. El enlace puede ser incorrecto o haber expirado.',
  invoice_status_sent: 'Enviada',
  invoice_status_viewed: 'Vista',
  invoice_subtotal: 'Subtotal',
  invoice_tax: 'Impuesto',
  invoice_title: 'Factura',
};
